<template>
  <div class="contract-prop-label">
    <poptip
      popper-class="contract-prop-label__modal"
      class="contract-prop-label__poptip"
      placement="right"
    >
      <div class="contract-prop-label__trigger ms-link">
        {{ label }}
      </div>

      <ul class="contract-prop-label__content" slot="content">
        <li
          v-for="row in listConfig"
          :key="row.id"
          class="contract-prop-label__row"
        >
          <div class="ms-help">
            {{ row.label }}
          </div>
          <div class="ms-text">
            {{ getValue(row.id) }}
          </div>
        </li>
      </ul>
    </poptip>
  </div>
</template>

<script>
const companyConfig = [
  { id: 'name', label: 'Название' },
  { id: 'full_name', label: 'Полное название' },
  { id: 'inn', label: 'ИНН' },
  { id: 'kpp', label: 'КПП' },
  { id: 'email', label: 'Эл. почта' },
  { id: 'phone', label: 'Телефон' },
  { id: 'address', label: 'Адрес' },
  { id: 'head_fio', label: 'Глава компании' }
]
const configs = {
  users: [
    { id: 'first_name', label: 'Имя' },
    { id: 'last_name', label: 'Фамилия' },
    { id: 'position', label: 'Должность' },
    { id: 'department', label: 'Отдел' },
    { id: 'email', label: 'Эл. почта' },
    { id: 'phone', label: 'Телефон' }
  ],
  own_companies: companyConfig,
  contragents: companyConfig
}

export default {
  props: {
    type: {
      type: String,
      default: 'users'
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    source: {
      type: Object
    }
  },
  computed: {
    sourceData () {
      const { type, id, source } = this

      switch (type) {
        case 'contragents':
          return source
        case 'own_companies':
          return this.$store.state.companies.find(u => u.id === id)
        default:
          return this.$store.state.users.find(u => u.id === id)
      }
    },
    listConfig () {
      return configs[this.type]
    }
  },
  methods: {
    getValue (key) {
      if (!this.sourceData) return '-'

      switch (key) {
        case 'position':
        case 'department': {
          return this.sourceData[key] ? this.sourceData[key].name : '-'
        }
        default: {
          return this.sourceData[key] || '–'
        }
      }
    }
  }
}
</script>

<style lang="less">
.contract-prop-label {
  &__trigger {
    cursor: pointer;
    text-decoration: underline;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__row {
    display: flex;
    gap: 8px;

    .ms-help {
      width: 104px;
      flex-shrink: 0;
    }
  }

  &__modal {
    max-width: 600px;
  }
}
</style>
